import { render, staticRenderFns } from "./cardQuestion.vue?vue&type=template&id=43db4e48&scoped=true&"
import script from "./cardQuestion.vue?vue&type=script&lang=js&"
export * from "./cardQuestion.vue?vue&type=script&lang=js&"
import style0 from "./cardQuestion.vue?vue&type=style&index=0&id=43db4e48&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43db4e48",
  null
  
)

export default component.exports